module.exports = __webpack_public_path__ + "static/en-section-3@2x-c608fa6802d2aa3ba345dfd3c16b04e8.png";